import React from 'react';
import { TrainingShell } from '../components/TrainingV2';

const DataQualityLineageTraining: React.FC = () => {
  return (
    <TrainingShell
      moduleId="data-quality-and-lineage"
      moduleName="Data Quality and Lineage"
      backUrl="/learn101"
    />
  );
};

export default DataQualityLineageTraining;
